import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularGuaranteeCheckmark: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_guarantee-checkmark"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="guarantee-checkmark icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M9.93381 1.06544L10.0102 1.21801L10.5867 2.75099C10.632 2.87171 10.7272 2.96697 10.848 3.01226L12.328 3.56753C12.9775 3.81121 13.3266 4.50524 13.1535 5.1619L13.1118 5.29259L12.4233 6.81541C12.3699 6.9328 12.3699 7.06751 12.4233 7.1849L13.0772 8.62411C13.3642 9.25568 13.1202 9.99324 12.5335 10.3352L12.3809 10.4116L10.848 10.9881C10.7272 11.0333 10.632 11.1286 10.5867 11.2493L10.0314 12.7294C9.78774 13.3789 9.0937 13.7279 8.43705 13.5549L8.30636 13.5132L6.78354 12.8246C6.66615 12.7713 6.53143 12.7713 6.41404 12.8246L4.97484 13.4786C4.34327 13.7655 3.60571 13.5216 3.26377 12.9349L3.18735 12.7823L2.61089 11.2493C2.5656 11.1286 2.47034 11.0333 2.34962 10.9881L0.869549 10.4328C0.220046 10.1891 -0.128977 9.49507 0.0440967 8.83842L0.0857385 8.70773L0.774305 7.1849C0.827644 7.06751 0.827644 6.9328 0.774305 6.81541L0.120374 5.3762C-0.166592 4.74463 0.0773694 4.00708 0.664076 3.66513L0.816641 3.58871L2.34962 3.01226C2.47034 2.96697 2.5656 2.87171 2.61089 2.75099L3.16617 1.27092C3.40984 0.621413 4.10388 0.27239 4.76053 0.445464L4.89122 0.487106L6.41404 1.17567C6.53143 1.22901 6.66615 1.22901 6.78354 1.17567L8.22274 0.521741C8.85431 0.234775 9.59187 0.478737 9.93381 1.06544ZM4.00245 1.58466L3.44718 3.06474C3.31131 3.4269 3.02554 3.71267 2.66337 3.84855L1.1833 4.40382L1.08531 4.45513C0.911279 4.57574 0.842876 4.8071 0.933571 5.00671L1.5875 6.44592C1.74752 6.79809 1.74752 7.20223 1.5875 7.55439L0.927563 9.00744L0.900565 9.09916C0.862788 9.30751 0.978021 9.51948 1.1833 9.59649L2.66337 10.1518C3.02554 10.2876 3.31131 10.5734 3.44718 10.9356L4.00245 12.4157L4.05376 12.5136C4.17437 12.6877 4.40574 12.7561 4.60534 12.6654L6.04455 12.0114C6.39672 11.8514 6.80086 11.8514 7.15303 12.0114L8.60607 12.6714L8.6978 12.6984C8.90614 12.7362 9.11811 12.6209 9.19513 12.4157L9.7504 10.9356C9.88627 10.5734 10.172 10.2876 10.5342 10.1518L12.0143 9.59649L12.1123 9.54519C12.2863 9.42458 12.3547 9.19321 12.264 8.9936L11.6101 7.55439C11.4501 7.20223 11.4501 6.79809 11.6101 6.44592L12.27 4.99287L12.297 4.90115C12.3348 4.6928 12.2196 4.48083 12.0143 4.40382L10.5342 3.84855C10.172 3.71267 9.88627 3.4269 9.7504 3.06474L9.19513 1.58466L9.14382 1.48668C9.02321 1.31265 8.79184 1.24424 8.59224 1.33494L7.15303 1.98887C6.80086 2.14888 6.39672 2.14888 6.04455 1.98887L4.60534 1.33494L4.57747 1.32339C4.34654 1.23675 4.08909 1.35373 4.00245 1.58466ZM5.57704 8.34681L8.76269 4.70607C8.92511 4.52044 9.20726 4.50163 9.39288 4.66405C9.5553 4.80617 9.59 5.03996 9.48733 5.22054L9.43489 5.29425L5.93489 9.29425C5.78604 9.46437 5.53843 9.49326 5.35648 9.37544L5.28299 9.31595L3.78299 7.81595C3.60859 7.64154 3.60859 7.35877 3.78299 7.18436C3.9356 7.03175 4.17118 7.01268 4.34453 7.12713L4.41459 7.18436L5.57704 8.34681L8.76269 4.70607L5.57704 8.34681Z" />
      </svg>
    </span>
  );
};

export { RegularGuaranteeCheckmark };
